import Vue from 'vue'
import Router from 'vue-router'
import Authentication from '@/components/Authentication'
import Register from '@/components/Register'
import Account from '@/components/Account'
import Questionnaire from '@/components/Questionnaire'
import TalentQuestionnaire from '@/components/TalentQuestionnaire'
import QuestionnaireInstructions from '@/components/Instructions'
import TalentInstructions from '@/components/TalentInstructions'
import Payment from '@/components/Payment'
import ForgotPassword from '@/components/ForgotPassword'
import BalanceSheetSale from '@/components/BalanceSheetSale'
import PageNotFound from '@/components/PageNotFound'
import { defaultLocale } from '../plugins/i18n'
import { ifAuthenticated, ifNotAuthenticated, isTalentApp } from '../services/User.service'
import store from '../store'

Vue.use(Router)

let componentQst = isTalentApp() ? TalentQuestionnaire : Questionnaire
let rouneNametQst = isTalentApp() ? 'questionnaire-talents' : 'questionnaire'
let componentIst = isTalentApp() ? TalentInstructions : QuestionnaireInstructions
let rouneNametIst = isTalentApp() ? 'talent-instructions' : 'questionnaire-instructions'

export const router = new Router({
  scrollBehavior() {
    $('html,body').stop().animate({
        scrollTop: 0
    }, 'slow', 'swing');
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: `/${defaultLocale}`,
    },
    {
    path: '/:locale',
    component: {
        template: '<router-view />'
    },
    children: [
        {
          path: '',
          name: 'Authentication',
          component: Authentication,
          beforeEnter: ifNotAuthenticated
        },
        {
          path: 'register',
          name: 'Register',
          component: Register,
          beforeEnter: ifNotAuthenticated
        },
        {
          path: 'account',
          name: 'Account',
          component: Account,
          beforeEnter: ifAuthenticated
        },
        {
          path: rouneNametQst,
          name: 'Questionnaire',
          component: componentQst,
          beforeEnter: ifAuthenticated
        },
        {
          path: rouneNametIst,
          name: 'QuestionnaireInstructions',
          component: componentIst,
          beforeEnter: ifAuthenticated
        },
        {
          path: 'forgot-password',
          name: 'ForgotPassword',
          component: ForgotPassword,
          beforeEnter: ifNotAuthenticated
        },
        {
          path: 'payment',
          name: 'Payment',
          component: Payment,
          beforeEnter: ifAuthenticated
        },
        {
          path: 'bilan-vente',
          name: 'BalanceSheetSale',
          component: BalanceSheetSale,
          beforeEnter: ifAuthenticated
        },
        {
          path: '*',
          name: '404',
          component: PageNotFound
        }
      ]
    }
  ]
});

router.beforeResolve((to, from, next) => {
  let lang = to.params.locale
  let pathTo = to.path

  if ( lang != defaultLocale && isTalentApp() ) {
    next({
      path: `/${defaultLocale}`
    });
  }
  // If this isn't an initial page load.
  if (to.name) {
      // Start the route progress bar.
      NProgress.start()
  }
  next()
})

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js